/**
 * Badge Google Play ufficiale.
 * Link al Play Store configurabile (default: Family Brain).
 * Rispetta le linee guida Google per il badge "Get it on Google Play":
 * https://play.google.com/intl/it_it/badges/
 */
export default function GooglePlayBadge({
  href = "https://play.google.com/store/apps/details?id=com.familybrain.myapp",
  className = "",
  width = 180,
  testId = "google-play-badge",
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`inline-flex items-center gap-3 bg-black text-white rounded-xl px-4 py-2.5 hover:bg-neutral-800 transition-colors ${className}`}
      style={{ minWidth: width }}
      aria-label="Scarica Family Brain su Google Play"
    >
      {/* Google Play SVG logo */}
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="w-7 h-7 shrink-0" aria-hidden="true">
        <path fill="#EA4335" d="M335.5 243.5 92 .3 353 150l-17.5 93.5z" />
        <path fill="#FBBC04" d="M451.3 221.3 353 150l-17.5 93.5L353 362l98.3-70.7c22.3-16.1 22.3-54 0-70z" />
        <path fill="#4285F4" d="M92 .3 335.5 243.5 92 511.7c-9.5-5.2-15.5-15.1-15.5-26.1V26.4C76.5 15.4 82.5 5.5 92 .3z" />
        <path fill="#34A853" d="m92 511.7 243.5-243.2L353 362 92 511.7z" />
      </svg>
      <div className="flex flex-col leading-tight">
        <span className="text-[9px] uppercase tracking-wide opacity-80">Disponibile su</span>
        <span className="font-semibold text-base">Google Play</span>
      </div>
    </a>
  );
}
